import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 8.8125C11.2782 8.8125 13.125 6.96567 13.125 4.6875C13.125 2.40933 11.2782 0.5625 9 0.5625C6.72183 0.5625 4.875 2.40933 4.875 4.6875C4.875 6.96567 6.72183 8.8125 9 8.8125Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9 9.9375C7.11094 9.93949 5.29982 10.6908 3.96406 12.0266C2.62829 13.3623 1.87699 15.1734 1.875 17.0625C1.875 17.162 1.91451 17.2573 1.98484 17.3277C2.05516 17.398 2.15054 17.4375 2.25 17.4375H15.75C15.8495 17.4375 15.9448 17.398 16.0152 17.3277C16.0855 17.2573 16.125 17.162 16.125 17.0625C16.123 15.1734 15.3717 13.3623 14.0359 12.0266C12.7002 10.6908 10.8891 9.93949 9 9.9375Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'userIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  size: {
    type: Number as PropType<number>,
    default: 18,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})